import React, { useState } from "react";
import { UTILS } from "utils";
import { API } from "api";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import AppInput from "components/ui/AppInput";
import AppHeading2 from "components/ui/AppHeading2";
import AppPhoneNumberInput from "components/ui/AppPhoneNumberInput";

const AddAdminUser = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    values: {
      name: "",
      email: "",
      brandId: "",
      phoneNumber: "",
      deviceType: "web",
      userType: "",
      password: "",
      confirmPassword: "",
    },
    errors: {
      name: "",
      email: "",
      brandId: "",
      phoneNumber: "",
      deviceType: "",
      userType: "",
      password: "",
      confirmPassword: "",
      language: "",
    },
  });

  const handleValues = (key, val) => {
    setUser((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const validateInputs = () => {
    let isValidForm = true;
    let obj = {
      errors: {
        name: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        userType: "",
      },
    };

    if (!user?.values?.email) {
      obj.errors.email = t("Field is required");
      isValidForm = false;
    }
    if (!user?.values?.name || UTILS.hasWhiteSpace(user.values.name)) {
      obj.errors.name = t("Field is required");
      isValidForm = false;
    } else if (!UTILS.emailValidation().test(user.values.email)) {
      obj.errors.email = t("Please enter correct email!");
      isValidForm = false;
    }

    if (!user?.values?.phoneNumber) {
      obj.errors.phoneNumber = t("Field is required");
      isValidForm = false;
    }

    if (!UTILS.isValidMobileNumber(user.values.phoneNumber)) {
      obj.errors.phoneNumber = t("Enter a valid mobile number");
      isValidForm = false;
    }

    if (user?.values?.password == "") {
      obj.errors.password = t("Field is required");
      isValidForm = false;
    }

    if (user?.values?.password?.length <= 6) {
      obj.errors.password = t("password should be 7 character long");
      isValidForm = false;
    }

    if (user?.values?.confirmPassword === "") {
      obj.errors.confirmPassword = t("Field is required");
      isValidForm = false;
    }

    if (user?.values?.password !== user.values.confirmPassword) {
      obj.errors.confirmPassword = t("password do not match");
      isValidForm = false;
    }

    setUser((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
      },
      errors: obj.errors,
    }));
    return isValidForm;
  };
  const addUser = async () => {
    user.values.email = user?.values?.email?.trim();
    if (validateInputs()) {
      setLoading(true);
      user.values.phoneNumber = await UTILS.formatPhoneNumber(
        user.values.phoneNumber
      );
      const userDetail = UTILS.getCurrentUser();
      let objUser = {
        ...user.values,
        brandId: userDetail.brandId,
        userType: "MANAGER",
      };
      const result = await API.ADD_USER({
        token: userDetail.token,
        user: objUser,
      });
      if (result.success === 1) {
        UTILS.successNotification(t("User Added Successfully"));
        props.callback();
        clearFields();
      } else {
        UTILS.errorNotification(result?.message);
      }
      setLoading(false);
    }
  };

  if (props.submitRef) {
    props.submitRef.current = addUser;
  }
  // clear all the fields
  const clearFields = () => {
    setUser((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        name: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        userType: "",
      },
    }));
  };
  return (
    <div >

    
        <AppHeading2>{t("User Information")}</AppHeading2>
        <Spin spinning={loading}>
          <div className="py-2">
            <AppInput label={t("Name")}
              value={user.values.name}
              placeholder="name"
              onChange={(e) => handleValues("name", e.target.value)}
              error={user.errors.name}
              mandatory={true}></AppInput>
          </div>
          <div className="py-2">
            <AppInput
              label={t("Email")}
              value={user.values.email}
              placeholder="email"
              onChange={(e) => handleValues("email", e.target.value)}
              error={user.errors.email}
              mandatory={true}
            ></AppInput>
          </div>
          <div className="py-2">
            <AppPhoneNumberInput
             label={t("Mobile Number")}
              value={user.values.phoneNumber}
              keyVal={"phoneNumber"}
              error={user.errors.phoneNumber}
              handleValues={handleValues}
              mandatory={true}
            >
            </AppPhoneNumberInput>
          </div>
          <div className="py-2">
            <AppInput
              label={t("Password")}
              type="password"
              placeholder="password"
              value={user.values.password}
              onChange={(e) => handleValues("password", e.target.value)}
              error={user.errors.password}
              mandatory={true}
            ></AppInput>
          </div>
          <div className="py-2">
            <AppInput
              label={t("Confirm Password")}
              type="password"
              placeholder="confirm password"
              value={user.values.confirmPassword}
              onChange={(e) => handleValues("confirmPassword", e.target.value)}
              error={user.errors.confirmPassword}
              mandatory={true}
            />

          </div>
        </Spin>
        </div>

  );
};

AddAdminUser.propTypes = {
  callback: PropTypes.func,
  submitRef: PropTypes.shape({ current: PropTypes.any }),
};
export default AddAdminUser;
